export default __webpack_public_path__ + "static/media/list.894ed7b1.svg";